import { MidPageHeading } from "./MidPageHeading";
import { ModalHeading } from "./ModalHeading";
import { PageHeading } from "./PageHeading";
import { SectionHeading } from "./SectionHeading";

import { PhoneMain } from "./PhoneMain";
import { PhoneSubBox } from "./PhoneSubBox";

export const Headings = {
  Page: PageHeading,
  MidPage: MidPageHeading,
  Section: SectionHeading,
  PhoneMain: PhoneMain,
  PhoneSubBox: PhoneSubBox,
  Modal: ModalHeading,
};
